import { createApiClient } from "@/api";

import { type RebillsGroupDto } from "./types";

const apiClient = createApiClient("json");
const BASE_URL = "/api/vpn/rebill_analytics/groups";

export const fetchRebillsGroupsListData = async () => {
  const response = await apiClient.GET(BASE_URL, {
    params: {
      query: {
        pagination: false,
      },
    },
  });
  const data =
    (response.data as unknown as RebillsGroupDto[] | undefined) ?? [];
  return {
    data,
    total: data.length,
  };
};
